import Button from "common/components/Button/Button";
import PageHeader from "common/components/PageHeader/PageHeader";
import Table from "common/components/Table/Table";
import TableAvatarTitle from "common/components/TableUtilities/TableAvatarTitle/TableAvatarTitle";
// import AlertsContext from 'common/contexts/alerts';
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import useList from "common/hooks/useList";
import React, {
  // eslint-disable-next-line comma-dangle
  useCallback,
  useEffect,
  useMemo,
} from "react";
import { useTranslation } from "react-i18next";

const urlLabel = "comments";

function Comments() {
  const { t } = useTranslation();
  const {
    fetchItems,
    items,
    isFetching,
    filters,
    setFilter,
    pageCount,
    setPageIndex,
    error,
    pageIndex,
    removeListItem,
  } = useList(urlLabel, { defaultFilters: {}, defaultSort: "id:DESC" });
  const { removeItem } = useItem(urlLabel, "");

  const { navigate } = useRouter();
  // const { isAdmin } = useAuth();

  const handleDelete = useCallback(
    async (id: any) => {
      removeListItem(id);
      await removeItem(id);
      fetchItems();
    },
    [removeListItem, fetchItems, removeItem]
  );

  // const { setAlert } = useContext(AlertsContext);

  useEffect(() => {
    if (error) {
      // setAlert(error, 'danger');
    }
  }, [error /* setAlert */]);

  const columns = useMemo(
    () => [
      {
        Header: t("common.ride"),
        filterName: "name$contains",
        className: "table-start",
        // eslint-disable-next-line react/no-unstable-nested-components
        Cell: ({
          row: {
            original: { id, user, content },
          },
        }: any) => (
          <TableAvatarTitle
            title={user?.username}
            link={`/${urlLabel}/edit/${id}`}
            secondTitle={content}
          />
        ),
      },
      {
        Header: t("common.actions"),
        className: "table-actions",
        // eslint-disable-next-line
        Cell: ({
          row: {
            original: { id },
          },
        }: any) => {
          // if (!isAdmin) return null;

          return (
            <>
              <Button
                onClick={() => navigate(`/${urlLabel}/edit/${id}`)}
                icon="fa-pencil-alt"
                color="primary"
                transparent
              />
              <Button
                // eslint-disable-next-line react/prop-types
                onClick={() => handleDelete(id)}
                icon="fa-trash-alt"
                color="danger"
                confirm
                transparent
                confirmMessage={t("common.delete")}
              />
            </>
          );
        },
      },
    ],
    [t, navigate, handleDelete /* isAdmin */]
  );

  return (
    <>
      <PageHeader
        title={t("common.comments")}
        link={{
          url: `/${urlLabel}/add`,
          icon: "plus",
          label: t("common.add"),
        }}
        subLink={{
          url: "/configure",
          icon: "arrow-left",
          label: t("common.back"),
        }}
      />
      <main className="flex-1">
        <section className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <Table
            data={items ?? []}
            columns={columns}
            isFetching={isFetching}
            pageCount={pageCount}
            filters={filters}
            setFilter={setFilter}
            setPageIndex={setPageIndex}
            pageIndex={pageIndex}
          />
        </section>
      </main>
    </>
  );
}

export default Comments;
